export function snakify(s: string): string {
  const newStr = s[0].toLowerCase() + s.slice(1);
  return newStr.replace(/([A-Z])/g, function ($1: string): string {
    return '_' + $1.toLowerCase();
  });
}
